import { useState } from 'react';

export enum CaseCreationPreferenceOptions {
  CreateCaseUsingEVerify = 'CreateCaseUsingEVerify',
  CreateCaseUsingEVerifyPlus = 'CreateCaseUsingEVerifyPlus',
  CreateCasePromptUser = 'CreateCasePromptUser',
}

const CASE_CREATION_KEY = 'CaseCreationPreference';
const DEFAULT_VALUE: CaseCreationPreferenceOptions = CaseCreationPreferenceOptions.CreateCasePromptUser;

function useCaseCreationPreference(): [CaseCreationPreferenceOptions, (value: CaseCreationPreferenceOptions) => void] {
  const [caseCreationType, setCaseCreationType] = useState<CaseCreationPreferenceOptions>(() => {
    try {
      const item = localStorage.getItem(CASE_CREATION_KEY);
      return item ? (item as CaseCreationPreferenceOptions) : DEFAULT_VALUE;
    } catch (error) {
      // No logger in ver-uds, so return default value
      return DEFAULT_VALUE;
    }
  });

  const setStoredCaseCreationType = (value: CaseCreationPreferenceOptions): void => {
    try {
      setCaseCreationType(value);
      localStorage.setItem(CASE_CREATION_KEY, value);
    } catch (error) {
      // No logger in ver-uds, so just fail silently
    }
  };

  return [caseCreationType, setStoredCaseCreationType];
}

export default useCaseCreationPreference;
